export function calculateReadingTime(primaryContent) {
  return primaryContent.reduce((total, node) => {
    return node.contentBody
      ? total + node.contentBody.childMarkdownRemark.timeToRead
      : total;
  }, 0);
}
